import { PremiumGate } from '../../platform/access/PremiumGate'
import { InlineLink } from '../../platform/primitives/InlineLink'

/**
 * Settings › Security › Data & privacy — the foot of the page.
 *
 * Points at the exports that already exist (the Transactions CSV on
 * `/transactions`, the Reports PDF on `/reports`) rather than running one here;
 * `report_exported` therefore fires where the export runs. No delete control.
 *
 * Gated on `export_data` like the exports themselves; the rest of Security is
 * not. The preview is a non-link rendering of the same lines, per
 * `PremiumGate`'s contract.
 */
export function DataPrivacy() {
  return (
    <section className="security__data" aria-labelledby="data-privacy-title">
      <h2 className="security__title" id="data-privacy-title">
        Data &amp; privacy
      </h2>
      <p className="security__lede">
        Download your data. Exports cover what&apos;s on your account today.
      </p>
      <PremiumGate
        entitlement="export_data"
        label="Data export"
        preview={
          <ul className="security__list">
            <li className="security__row">
              <div className="security__factor">
                <span className="security__name">Export transactions (CSV)</span>
                <span className="security__added">Choose a month, then Export</span>
              </div>
            </li>
            <li className="security__row">
              <span className="security__name">Export a report (PDF)</span>
            </li>
          </ul>
        }
      >
        <ul className="security__list">
          <li className="security__row">
            <div className="security__factor">
              <InlineLink to="/transactions">Export transactions (CSV)</InlineLink>
              <span className="security__added">Choose a month, then Export</span>
            </div>
          </li>
          <li className="security__row">
            <InlineLink to="/reports">Export a report (PDF)</InlineLink>
          </li>
        </ul>
      </PremiumGate>
    </section>
  )
}
